import dayjs from 'dayjs'

export function getCookie(name) {
  if (!name) return
  return localStorage.getItem(name)
}

export function setCookie(name, content) {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  return localStorage.setItem(name, content)
}

export function removeCookie(name) {
  if (!name) return
  const arr = name.split(' ')
  arr.forEach(name => {
    localStorage.removeItem(name)
  })
}

export function transformTime(timestamp) {
    if(timestamp.length == 10){
      var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    }else{
      var date = new Date(timestamp);
    }
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    let D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate());
    return Y+M+D;
}

export function transformTimeYYMM(timestamp) {
  if(timestamp.length == 10){
    var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  }else{
    var date = new Date(timestamp);
  }
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
  return Y+M;
}

export function getSevenDate(today, addDayCount) {
  var date;
  if(today) {
    date = new Date(today);
  }else{
    date = new Date();
  }
  date.setDate(date.getDate() + addDayCount);//获取AddDayCount天后的日期 
  var y = date.getFullYear();
  var m = date.getMonth();//获取当前月份的日期 
  var d = date.getDate();
  return new Date(y, m, d);
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * 获取两个日期之间的所有日期
 * @param param1 开始日期
 * @param param2 结束日期
 */
export function intervalDates(param1, param2 ) {
  const startDate = dayjs(param1);
  const endDate = dayjs(param2); 
  const diff = endDate.diff(startDate, 'day') + 1;
  let dates = [];
  for (let i = 0; i < diff; i++) {
    const date = dayjs(startDate.add(i, 'day')).format('YYYY-MM-DD');
    dates.push(date.substring(5));
  }
  return dates
}
